import classNames from 'classnames';

import styles from './_index.module.scss';

export interface LoaderProps extends React.HTMLAttributes<HTMLDivElement> {
  isCentered?: boolean;
  isVerticallyCentered?: boolean;
}

const Loader = ({ isCentered, isVerticallyCentered }: LoaderProps) => {
  return (
    <div
      className={classNames(styles[`loader`], {
        [styles['is-centered']]: isCentered,
        [styles['is-vertically-centered']]: isVerticallyCentered,
      })}
    >
      {[...Array(4)].map((bar, index) => (
        <div key={`loader-${index}`}>
          <div />
        </div>
      ))}
    </div>
  );
};

export default Loader;
